import store from 'shared/store'
import { NOW_SHIPPING_MODAL_CART_CONTAINER_ID } from 'views/components/organisms/NowShippingModal/names'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

const hydrateAndMountComponent = ({
  wrappingElement,
  wrappedComponent,
  i18n,
}) => {
  wrappedComponent({
    container: wrappingElement,
    i18n,
  })
}

const mountNowShippingModalCartContainer = async () => {
  const modal = document.getElementById(NOW_SHIPPING_MODAL_CART_CONTAINER_ID)

  if (!modal) {
    return
  }

  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()

  const i18n = await loadCatalogs(locale)

  const nowShippingModalContainer = await import(
    /* webpackChunkName: "NowShippingModalContainerWithHydration" */
    './NowShippingModalContainerWithHydration'
  )

  hydrateAndMountComponent({
    wrappingElement: modal,
    wrappedComponent: nowShippingModalContainer.default,
    i18n,
  })
}

export default mountNowShippingModalCartContainer
